import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  list: [],
};

const SongListSlice = createSlice({
  name: "SongList",
  initialState,
  reducers: {
    songListSuccess(state, action) {
      state.list = action.payload
    },
  },
});

export const {
  songListSuccess,
} = SongListSlice.actions

export default SongListSlice.reducer;
